<template>
  <div class="footercard">
    <div class="aboutwe flex_layout">
      <div class="xinxibox flex_layout">
        <div class="title" v-if="!isMobile">联系<br />我们</div>
        <div class="tag" v-if="!isMobile"></div>
        <div class="info">
          <div class="phone">
            <div>联系电话：</div>
            <div>
              13910648827 万老师 <br />
            </div>
          </div>
          <div class="address">
            北京市朝阳区东四环中路41号嘉泰国际大厦B座4层
          </div>
        </div>
      </div>
      <div class="ewmbox display-none">
        <img src="../assets/image/wx2.png" alt="" />
        <p>扫码进报名群</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.footercard {
  padding: 50px 0;
  @media screen and (max-width: 540px) {
    padding: 20px 0;
  }
  .aboutwe {
    justify-content: center;
    @media screen and (max-width: 540px) {
      display: block;
    }
    .xinxibox {
      padding-right: 130px;
      font-weight: 400;
      font-size: 20px;
      color: #000000;
      @media screen and (max-width: 540px) {
        padding-right: 0;
        display: block;
        text-align: center;
        padding: 15px;
      }
      .title {
        font-weight: 500;
        font-size: 30px;
        color: #05258e;
      }
      .tag {
        width: 1px;
        height: -webkit-fill-available;
        margin: 0 35px;
        background: #000000;
      }
      .phone {
        display: flex;
        margin-bottom: 10px;
        @media screen and (max-width: 540px) {
          justify-content: center;
        }
      }
    }
    .display-none{
      display: none !important;
    }
    .ewmbox {
      width: 150px;
      padding: 10px;
      box-sizing: border-box;
      background: #fff;
      @media screen and (max-width: 540px) {
        flex: 1;
        margin:  auto;
      }
      img {
        display: block;
        width: 130px;
        height: 130px;
        margin: auto;
        @media screen and (max-width: 540px) {
          width: 100px;
          height: 100px;
        }
      }
      p {
        color: #363636;
        padding-top: 6px;
        text-align: center;
        @media screen and (max-width: 540px) {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
